<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="录入 质检日志"
      id-key="TestId"
      :data="data"
      :get-data-func="api.info"
      @closed="onClosed"
      @edit-opened="editOpen"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
           <el-col :span="7">
              <el-form-item label="订单编号" prop="OrderNo">
                <div class="detail-span">{{data.OrderNo}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单编号" prop="WorkDocNo">
                <div class="detail-span">{{data.WorkDocNo}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="质检日期" prop="TestDate">
                <div class="detail-span">{{$commonJs.toDateString(data.TestDate)}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="情况描述" prop="Remark">
                <div class="detail-span">{{data.Remark}}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-table class="table-line tb-c-head" style="margin-top: 20px;" :data="data.Dts" border>
         <el-table-column label="产品编码" prop="ProductNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="产品名称" prop="ProductName" min-width="120" show-overflow-tooltip />
          <el-table-column label="本次检验数量" prop="ThisTestQuantity" width="110" />
          <el-table-column label="本次合格数量" prop="PassQuantity" width="110" />
          <el-table-column label="本次不合格数量" prop="FailQuantity" width="110" />
        </el-table>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/pr/test").default,
    //  api: require("@/api/sy/user").default,
      data: {
        TestId: 0,
        WorkDocId: null,
        WorkDocNo: "",
        OrderNo: "",
        TestDate: null,
        Dts: [],
      },
    };
  },
  computed: {},
  methods: {
    onClosed() {
      this.data.Dts = [];
    },
    editOpen(data) {
      this.data.Dts = [];
      this.data.Dts.push(data)
    }
  },
};
</script>